export default {
	Sales: 1,
	Purchases: 2,
};



// WEBPACK FOOTER //
// ./src/shared/flag-type.js